module.exports = __webpack_public_path__ + "img/prev-icon.ef4457fc.svg";